import { defineComponent as e } from "vue";
const n = e({
  name: "MobileMenu",
  props: {
    showMenu: {
      type: Boolean,
      default: !1
    }
  }
});
export {
  n as default
};
//# sourceMappingURL=index41.js.map
